import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { INoticia } from "../../Interfaces/model/INoticia";
import { Loading } from "../../components/loading";
import { PageNotFound } from "../../components/pageNotFound";
import noticiaService from "../../services/noticiaService";
import { Notify } from "../../utils/notify";
import { scrollUp } from "../../utils/pageUtils";
import { Preview } from "./components/previews";
import { NewsPageContainer } from "./styles";

export const News = () => {
  const { slug } = useParams();
  const [news, setNews] = useState<INoticia | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [notFound, setNotFound] = useState<boolean>(false);

  useEffect(() => {
    scrollUp();

    if (!slug) {
      setNotFound(true);
      setIsLoading(false);
      return;
    }

    noticiaService
      .getNoticiaSlug(slug)
      .then((response) => setNews(response.data))
      .catch(() => {
        setNotFound(true);
        Notify.failure("Não foi possível carregar a notícia.");
      })
      .finally(() => setIsLoading(false));
  }, [slug]);

  if (!isLoading && notFound) {
    return <PageNotFound isPageNotFound />;
  }

  return (
    <NewsPageContainer>
      <Loading isLoading={isLoading} />
      {!isLoading && news && <Preview news={news} />}
    </NewsPageContainer>
  );
};
